import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (navigator.sendBeacon) {
      const url = "/beacon"
      const formData = new FormData()
      const csrfParam = document.querySelector("meta[name=csrf-param]").getAttribute("content")
      const csrfToken = document.querySelector("meta[name=csrf-token]").getAttribute("content")
      formData.append(csrfParam, csrfToken)
      formData.append("page", window.location.pathname)
      navigator.sendBeacon(url, formData)
    }
  }

}